import CreateAreaTypeContainer from "./CreateAreaTypeContainer";
export default CreateAreaTypeContainer;
